module.exports = new __parcel__URL__("jpd-portfolio-management-capacity-planning.31658e30.svg").toString();